import { unstable_ClassNameGenerator as ClassNameGenerator } from '@mui/material/className'

// Configure the class name generator
ClassNameGenerator.configure((componentName) => `mui-jss-${componentName}`)

// Example usage
export const generateClassName = (componentName) => `mui-jss-${componentName}`
